import { Typography, SxProps, Theme, Box } from 'ui/mui';
import Link from 'ui/components/Link';
import { darkModeColors } from 'ui/theme/theme';

type FooterBottomBarLinkProps = {
  href?: string;
  onClick?: () => void;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  target?: string;
  external?: boolean;
};

const linkStyles = {
  color: darkModeColors.text.primary,
  textDecoration: 'underline',
  '&:visited': {
    color: darkModeColors.text.primary,
  },
  '&:hover': {
    color: darkModeColors.text.primary,
  },
  '&:focus': {
    color: darkModeColors.text.primary,
  },
  '&:focus-visible': {
    outlineColor: '#fff',
    color: darkModeColors.text.primary,
  },
};

export const FooterBottomBarLink = ({
  href,
  onClick,
  children,
  sx,
  target,
  external,
}: FooterBottomBarLinkProps) => {
  if (onClick) {
    return (
      <Link
        component='button'
        onClick={onClick}
        sx={{
          ...linkStyles,
          cursor: 'pointer',
          ...sx,
        }}
      >
        {children}
      </Link>
    );
  }

  return (
    <Link
      target={target}
      href={href}
      external={external}
      sx={{
        ...linkStyles,
        ...sx,
      }}
    >
      {children}
    </Link>
  );
};
